import axios from 'axios';

const web = axios.create({
    baseURL: '/',
});

web.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default web;
